import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      if (data.primary_color) {
        document.documentElement.style.setProperty("--primary", data.primary_color);
        document.documentElement.style.setProperty("--ring", data.primary_color);
      }
      if (data.secondary_color) {
        document.documentElement.style.setProperty("--secondary", data.secondary_color);
        document.documentElement.style.setProperty("--accent", data.secondary_color);
      }
      if (data.seo_title) document.title = data.seo_title;
    } catch (e) {
      console.warn("Settings load failed", e);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
